<div [formGroup]="clientTransactionViewForm">
    <div class="row">
      <div class="product-detail-row1 product-detail-row">
        <div class="field-wrapper field-wrapper-row-1">
          <div class="order-title order-title-desc">ההזמנה שלך</div>
          <div class="order-title order-title-mob">
            {{ pUiService.productView.ProductItem.Name }}
          </div>
          <div class="row">
            <div class="col-md-12">
              <div
                class="col-md-12 comment-alert alert-danger"
                *ngIf="pUiService.displayGeneralComment"
              >
                שים לב: המחיר עודכן עקב שינוי
                <span
                  [innerHtml]="
                  pUiService.chosenOption.ProductOptionItem.ApartmentSizeTypeTxt
                  "
                ></span>
                .ראה מחירון המסומן בכחול בתחתית הדף
              </div>
            </div>
          </div>

          <div class="row">
            <div class="apartment-size col-md-6">
              <div class="form-group col-md-12">
                <label
                  for="apartment-size"
                  class="title-label"
                  [innerHtml]="
                  pUiService.chosenOption.ProductOptionItem.ApartmentSizeTypeTxt
                  "
                >
                  <!--  גודל חלל מבוקש במ"ר -->
                </label>

                <input
                  type="number"
                  step="1"
                  class="form-control"
                  id="apartment-size"
                  [formControl]="apartmentSize"
                />
                <div for="file-list" *ngIf="pUiService.testFields[0]" class="alert-danger">
                  <div *ngIf="!chosenOptionDoesNotExist">
                    <span>אנא מלא</span>
                    <span
                    [innerHtml]="
                    pUiService.chosenOption.ProductOptionItem.ApartmentSizeTypeTxt
                    "
                  ></span>
                  </div>                 
                   <div *ngIf="chosenOptionDoesNotExist"> אנחנו לא מציעים
                    {{pUiService.chosenOption.ProductOptionItem.ApartmentSizeTypeTxt}} במידה זו
                   </div>
                </div>
              </div>
            </div>
            <div class="times-to-get-prodact col-md-6" *ngIf="pUiService.chosenOption.DayAndPricesItems && pUiService.chosenOption.DayAndPricesItems.length>0">
              <div class="form-group col-md-12">
                <label for="time-to-get-project" class="title-label"
                  >זמן לקבלת התוכנית</label
                >
                <div class="debug-data">{{ timeToGetProgramInDays.value}}</div>
                <select
                  [ngClass]="{ changedField: pUiService.markedFields[0] }"
                  [formControl]="timeToGetProgramInDays"
                  id="time-to-get-project"
                  class="form-control"
                >
                  <option
                    *ngFor="let daysPrice of pUiService.chosenOption.DayAndPricesItems"
                    [selected]="timeToGetProgramInDays.value === daysPrice.Days"
                    [value]="daysPrice.Days"
                  >
                    <ng-container *ngIf="daysPrice.Days > 1"
                      >{{ daysPrice.Days }} ימים</ng-container
                    >
                    <ng-container *ngIf="daysPrice.Days == 1"
                      >יום אחד</ng-container
                    >
                  </option>
                </select>
                <span
                  class="add-money-field selected-day"
                  *ngIf="getSelectedDayPrice() > 0"
                  >+ {{ getSelectedDayPrice()| number: pUiService.DECIMAL_RULE }} ש"ח</span
                >
              </div>
            </div>
            <div class="exist-file-format col-md-6" *ngIf="pUiService.chosenOption.ExistFileFormatItems && pUiService.chosenOption.ExistFileFormatItems.length>0">
              <div class="form-group col-md-12">
                <label for="exist-format" class="title-label">
                  פורמט תוכנית קיימת</label
                >
                <ng-template #tipContent1>
                  <div class="help-tooltip">
                    סוג הקובץ של התכנית שיש ברשותך. <br />קובץ תמונה : JPEG
                    (תמונה מהטלפון/צילום מסך וכדו') <br />קובץ מסמך סרוק: PDF
                    <br />קובץ של תכנת שירטוט אוטוקד: DWG (קיימת אצל אדריכלים
                    ובמחלקות שינויי הדיירים של הקבלנים) <br />בסיומת כל קובץ
                    תוכלו לזהות בעצמכם את סוג הקובץ: xy.dwg, xy.jpeg, xy.pdf
                  </div>
                </ng-template>
                <span
                  class="help-icon"
                  placement="top"
                  [ngbTooltip]="tipContent1"
                  triggers="click:blur"
                  >?</span
                >
                <div class="debug-data">
                  {{ existFileFormat.value }}
                </div>
                <select
                  [ngClass]="{ changedField: pUiService.markedFields[1] }"
                  id="exist-format"
                  [formControl]="existFileFormat"
                  class="form-control"
                >
                  <option
                    *ngFor="
                      let existFileFormatItem of pUiService.chosenOption.ExistFileFormatItems
                    "
                    [selected]="
                    existFileFormat.value ===
                    existFileFormatItem.FormatName
                    "
                    [value]="existFileFormatItem.FormatName"
                  >
                    {{ existFileFormatItem.FormatName }}
                  </option>
                </select>
                <span
                  class="add-money-field"
                  *ngIf="getSelectedExistFileFormatPrice() > 0"
                  >+
                  {{
                    getSelectedExistFileFormatPrice() * apartmentSize.value | number: pUiService.DECIMAL_RULE
                  }}
                  ₪</span
                >
              </div>
            </div>

            <div class="final-file-format col-md-6" *ngIf="pUiService.chosenOption.AvailableFileFormatItems && pUiService.chosenOption.AvailableFileFormatItems.length>0">
              <div class="form-group col-md-12">
                <label for="inputState" class="title-label">
                  פורמט תוכנית סופית</label
                >
                <ng-template #tipContent2>
                  <div class="help-tooltip">
                    סוג הקובץ שאת/ה רוצה לקבל
                    <br />
                    קובץ תמונה : JPEG (תמונה מהטלפון/צילום מסך וכדו')<br />
                    קובץ מסמך סרוק: PDF<br />
                    קובץ של תכנת שירטוט אוטוקד: DWG **רק במידה ורוצים שיהיה
                    אצלכם את התכנית ממוחשבת <br />
                    בסיומת כל קובץ תוכלו לזהות בעצמכם את סוג הקובץ: x.dwg,
                    x.jpeg, x.pdf
                  </div>
                </ng-template>
                <a
                  class="help-icon"
                  triggers="click:blur"
                  placement="top"
                  [ngbTooltip]="tipContent2"
                  >?</a
                >
                <select
                  [ngClass]="{ changedField: pUiService.markedFields[2] }"
                  id="AvailbleFileFormatItem"
                  [formControl]="wantedFileFormat"
                  class="form-control"
                >
                  <option
                    *ngFor="
                      let availableFileFormatItem of pUiService.chosenOption.AvailableFileFormatItems
                    "
                    [selected]="
                    availableFileFormatItem.FormatName ===
                    wantedFileFormat.value
                    "
                    [value]="availableFileFormatItem.FormatName"
                  >
                    {{ availableFileFormatItem.FormatName }}
                  </option>
                </select>
                <span
                  class="add-money-field"
                  *ngIf="getSelectedWantedFileFormatPrice() > 0"
                  >+ {{ getSelectedWantedFileFormatPrice()| number: pUiService.DECIMAL_RULE }} ₪</span
                >
              </div>
            </div>

            <div class="times-to-get-prodact col-md-6" *ngIf="pUiService.chosenOption.FixesPricesItems && pUiService.chosenOption.FixesPricesItems.length>0">
              <div class="form-group col-md-12">
                <label for="number-of-fixes" class="title-label">
                  מספר תיקונים אפשרי</label
                >
                <ng-template #tipContent3>
                  <div class="help-tooltip">
                    כמות התיקונים המרבית שתוכלו לבקש לאחר שהתכנית הראשונית נשלחה
                    אליכם ממערכת תכנון אונליין.
                  </div>
                </ng-template>
                <span
                  class="help-icon"
                  triggers="click:blur"
                  placement="top"
                  [ngbTooltip]="tipContent3"
                  >?</span
                >
                <div class="debug-data">{{ clientTransactionForm.get('FixesTimes').value }}</div>
                <select
                  [ngClass]="{ changedField: pUiService.markedFields[3] }"
                  id="number-of-fixes"
                  [formControl]="fixesTimes"
                  class="form-control"
                >
                  <option
                    *ngFor="
                      let fixesPricesItems of pUiService.chosenOption.FixesPricesItems
                    "
                    [selected]="
                    clientTransactionForm.get('FixesTimes').value  ===
                    fixesPricesItems.NumberOfFixes
                    "
                    [value]="fixesPricesItems.NumberOfFixes"
                  >
                    {{ fixesPricesItems.NumberOfFixes }}
                  </option>
                </select>
                <span
                  class="number-of-fixes-price add-money-field"
                  *ngIf="getSelectedFixTimePrice() > 0"
                  >+ {{ getSelectedFixTimePrice() | number: pUiService.DECIMAL_RULE}} ₪</span
                >
              </div>
            </div>

            
            
          </div>
          <app-dynamic-option-fields *ngIf="
          pUiService.productView.ProductOptionItems[pUiService.currentOptionIndex] &&
          pUiService.productView.ProductOptionItems[pUiService.currentOptionIndex]
              .DynamicProductOptions
          " [clientTransactionViewForm]="clientTransactionViewForm"></app-dynamic-option-fields>
            
<div class="row">
  <div class="price-list-btn-wrapper">
    <div class="price-list-btn" (click)="scrollToPriceList()">
      לחץ למחירון
    </div>
  </div>
  <div class="col-md-12">
    <div class="order-btn-detail order-btn-top" (click)="continueOrder(1)">
      <div class="final-price-num">{{ pUiService.finalPrice.value | number: pUiService.DECIMAL_RULE }} ₪</div>
      להמשך מילוי פרטי הזמנה
    </div>
  </div>
</div>
        </div>

        <app-plan-examples 
        [productPictureItems]="pUiService.productView.ProductPictureItems"
        ></app-plan-examples>
        
      </div>
    </div>
    <div class="order-btn-detail order-btn-top2" (click)="continueOrder(1)">
      <div class="final-price-num">{{ pUiService.finalPrice.value | number: pUiService.DECIMAL_RULE }} ₪</div>
      להמשך מילוי פרטי אלי הזמנה
    </div>
  </div>
  